import { Injectable } from '@angular/core';
import { RentalContractId } from '@rtls/core/models/thing/rental-contract-id.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DataServiceConfig } from 'data';
import { environment } from '@rtls-environment/environment';

@Injectable()
export class RentalContractService {
	private url = `${environment.thingsApi}/iv1/rental-contract`;
	constructor(
		private config: DataServiceConfig,
		private http: HttpClient,
	) {}
	getAllRentalContractIds(): Observable<RentalContractId[]> {
		return this.http.get<RentalContractId[]>(`${this.url}/get-all`);
	}
}
